// The Cierres panels' title: the logo of the client its screens are on (the one the header's
// selector chose). Without a logo, the client's name; before the client list arrives, "Cierres".
import { opcionDeCliente } from "../../../utils/cierreCliente";
import { useClienteCierres } from "./ClienteCierresContext";
import { LogoCliente } from "./LogoCliente";

export function TituloCierres() {
  const { clientes, clientCode } = useClienteCierres();
  const cliente = (clientes || []).map(opcionDeCliente).find((o) => o.valor && o.valor === clientCode);

  return (
    <h1 className="flex min-w-0 items-center gap-2 font-lora text-[21px] font-semibold text-brinks-foreground">
      {cliente ? (
        <LogoCliente key={cliente.logo} src={cliente.logo} nombre={cliente.etiqueta} className="h-[22px] max-w-[200px]">
          <span className="truncate">{cliente.etiqueta}</span>
        </LogoCliente>
      ) : (
        <span>Cierres</span>
      )}
    </h1>
  );
}
